<template>
	<v-dialog
		:value="value" @input="$emit('input')"
		max-width="574">
		<div class="dialog-wrapper error-dialog">
			<div class="dialog-header">
				<h2>Oops!</h2>
			</div>
			<div class="dialog-content bordered">
				Something went wrong
			</div>
			<div class="dialog-actions">
				<button 
					type="button" 
					class="tetriatary_btn" 
					@click="dialog = false" 
					v-ripple
				>
					Cancel
				</button>
				<a 
					:href="reportMailTo" 
					class="primary_btn" 
					@click="dialog = false" 
					v-ripple
				>
					Report
				</a>
			</div>
		</div>
	</v-dialog>
</template>

<script>
export default {
	name: "error",
	props: {
		value: Boolean,
		errorDetails: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		dialog: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value)
			}
		},
		reportMailTo() {
			const subject = encodeURIComponent('Found a bug!');
			let body = encodeURIComponent('Error Details:\n');
			
			if (this.errorDetails) {
				if (this.errorDetails.message) {
					body += encodeURIComponent(`\nMessage: ${this.errorDetails.message}`);
				}
				if (this.errorDetails.description) {
					body += encodeURIComponent(`\nDescription: ${this.errorDetails.description}`);
				}
				if (this.errorDetails.path) {
					body += encodeURIComponent(`\nPath: ${this.errorDetails.path}`);
				}
			}
			
			return `mailto:info.psytrance.network@gmail.com?subject=${subject}&body=${body}`;
		}
	}
}
</script>

<style lang="scss">
@import "../../assets/styles/mixins/dialog-mixins";

.error-dialog {
	@include dialog((
		has-header: true,
		has-content: true,
		has-actions: true,
		content-bordered: true
	));
}
</style>
